module.exports = "<div class=\"cardtb1-container\">\r\n\r\n  <div class=\"cardtb2-container\">\r\n    <div class=\"icontb\">\r\n      <img src=\"../../assets/logourmeobleu.png\" width=\"90px\" height=\"90px\">\r\n    </div>\r\n    <mat-card class=\"cardtb3-container\">\r\n      <ng-content></ng-content>\r\n    </mat-card>\r\n  </div>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/dev/Perso/urmeo/src/app/toolbox/card/card.component.html
// module id = ../../../../../src/app/toolbox/card/card.component.html
// module chunks = main